import TripItemCancellationMessage from './trip-item-cancellation-message-component';
import TripItemCancellationMessageService from './trip-item-cancellation-message-service';

const MODULE_NAME = 'app.trip.item-cancellation-messsage';
const module = angular.module(MODULE_NAME, [])
    .directive(TripItemCancellationMessage.DIRECTIVE_NAME, TripItemCancellationMessage)
    .service('tripItemCancellationMessageService', TripItemCancellationMessageService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-cancellation-message/trip-item-cancellation-message-module.js